import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from './../../shared/shared.module';
import { LoginComponent } from './login.component';
import { LoginService } from './login.service';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [LoginComponent],
  providers: [LoginService]
})
export class LoginModule {}
